var exports = {
  "W": "x31de4314--1ef74b--labels",
};

module.exports = exports;
